var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",attrs:{"href":_vm.section.link,"aria-label":_vm.section.title}},[_c('v-lazy-image',{attrs:{"src":_vm.section.icon.source,"alt":_vm.section.icon.alt,"width":"24","height":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }